export default __webpack_public_path__ + "static/litgateway-546e7e16c5122cac3cbfb97b39485297.jpg";